var map = {
	".": 72812,
	"./": 72812,
	"./15052025_App": 4416,
	"./15052025_App.js": 4416,
	"./15052025_Home": 55780,
	"./15052025_Home.js": 55780,
	"./15052025_Navbar": 49029,
	"./15052025_Navbar.js": 49029,
	"./Achievements": 86326,
	"./Achievements.js": 86326,
	"./App": 54111,
	"./App.js": 54111,
	"./Applications": 72369,
	"./Applications.js": 72369,
	"./AsSeenIn": 3386,
	"./AsSeenIn.js": 3386,
	"./BreadCrumbs": 41882,
	"./BreadCrumbs.js": 41882,
	"./Carousel": 43444,
	"./Carousel.js": 43444,
	"./Company": 60541,
	"./Company.js": 60541,
	"./ContactUs": 20561,
	"./ContactUs.js": 20561,
	"./Cover": 90875,
	"./Cover.js": 90875,
	"./FarewellMessage": 85063,
	"./FarewellMessage.js": 85063,
	"./Footer": 86913,
	"./Footer.js": 86913,
	"./Home": 65541,
	"./Home.js": 65541,
	"./LanguageSelector": 86041,
	"./LanguageSelector.js": 86041,
	"./Mission": 15966,
	"./Mission.js": 15966,
	"./Navbar": 48804,
	"./Navbar.js": 48804,
	"./ProgressBar": 42024,
	"./ProgressBar.js": 42024,
	"./PublicationsAndPatents": 80797,
	"./PublicationsAndPatents.js": 80797,
	"./References": 22988,
	"./References.js": 22988,
	"./Roadmap": 11957,
	"./Roadmap.js": 11957,
	"./ScrollUpButton": 82674,
	"./ScrollUpButton.js": 82674,
	"./Socials": 11860,
	"./Socials.js": 11860,
	"./Team": 37887,
	"./Team.js": 37887,
	"./Technology": 98040,
	"./Technology.js": 98040,
	"./_PublicationsAndPatents": 23690,
	"./_PublicationsAndPatents.js": 23690,
	"./index": 72812,
	"./index.js": 72812,
	"./jsons/en/achievements_en": 10019,
	"./jsons/en/achievements_en.json": 10019,
	"./jsons/en/applications_en": 13878,
	"./jsons/en/applications_en.json": 13878,
	"./jsons/en/as_seen_in_en": 87435,
	"./jsons/en/as_seen_in_en.json": 87435,
	"./jsons/en/carousel_en": 24789,
	"./jsons/en/carousel_en.json": 24789,
	"./jsons/en/company_en": 98832,
	"./jsons/en/company_en.json": 98832,
	"./jsons/en/contact_us_en": 54484,
	"./jsons/en/contact_us_en.json": 54484,
	"./jsons/en/cover_en": 45856,
	"./jsons/en/cover_en.json": 45856,
	"./jsons/en/farewell_message_en": 53955,
	"./jsons/en/farewell_message_en.json": 53955,
	"./jsons/en/footer_en": 56774,
	"./jsons/en/footer_en.json": 56774,
	"./jsons/en/mission_en": 20591,
	"./jsons/en/mission_en.json": 20591,
	"./jsons/en/navbar_en": 44181,
	"./jsons/en/navbar_en.json": 44181,
	"./jsons/en/publications_and_patents_en": 50544,
	"./jsons/en/publications_and_patents_en.json": 50544,
	"./jsons/en/references_en": 62317,
	"./jsons/en/references_en.json": 62317,
	"./jsons/en/roadmap_en": 83441,
	"./jsons/en/roadmap_en.json": 83441,
	"./jsons/en/socials_en": 58985,
	"./jsons/en/socials_en.json": 58985,
	"./jsons/en/team_en": 9640,
	"./jsons/en/team_en.json": 9640,
	"./jsons/en/technology_en": 9629,
	"./jsons/en/technology_en.json": 9629,
	"./jsons/pt/achievements_pt": 31731,
	"./jsons/pt/achievements_pt.json": 31731,
	"./jsons/pt/applications_pt": 87782,
	"./jsons/pt/applications_pt.json": 87782,
	"./jsons/pt/as_seen_in_pt": 25803,
	"./jsons/pt/as_seen_in_pt.json": 25803,
	"./jsons/pt/carousel_pt": 1205,
	"./jsons/pt/carousel_pt.json": 1205,
	"./jsons/pt/company_pt": 62598,
	"./jsons/pt/company_pt.json": 62598,
	"./jsons/pt/contact_us_pt": 59600,
	"./jsons/pt/contact_us_pt.json": 59600,
	"./jsons/pt/cover_pt": 84046,
	"./jsons/pt/cover_pt.json": 84046,
	"./jsons/pt/farewell_message_pt": 53507,
	"./jsons/pt/farewell_message_pt.json": 53507,
	"./jsons/pt/footer_pt": 34290,
	"./jsons/pt/footer_pt.json": 34290,
	"./jsons/pt/mission_pt": 95557,
	"./jsons/pt/mission_pt.json": 95557,
	"./jsons/pt/navbar_pt": 64117,
	"./jsons/pt/navbar_pt.json": 64117,
	"./jsons/pt/publications_and_patents_pt": 31104,
	"./jsons/pt/publications_and_patents_pt.json": 31104,
	"./jsons/pt/references_pt": 89725,
	"./jsons/pt/references_pt.json": 89725,
	"./jsons/pt/roadmap_pt": 77083,
	"./jsons/pt/roadmap_pt.json": 77083,
	"./jsons/pt/socials_pt": 41955,
	"./jsons/pt/socials_pt.json": 41955,
	"./jsons/pt/team_pt": 76956,
	"./jsons/pt/team_pt.json": 76956,
	"./jsons/pt/technology_pt": 36369,
	"./jsons/pt/technology_pt.json": 36369,
	"./resources/icons/F6S.png": 92712,
	"./resources/icons/F6S_icon_red.png": 11830,
	"./resources/icons/Subtract.png": 39739,
	"./resources/icons/Subtract.svg": 22347,
	"./resources/icons/about_us.png": 27933,
	"./resources/icons/arrow.png": 85844,
	"./resources/icons/arrow_down.png": 61601,
	"./resources/icons/arrow_grey.png": 48552,
	"./resources/icons/arrow_red.png": 45868,
	"./resources/icons/arrow_white.png": 59266,
	"./resources/icons/awards_and_news.png": 56713,
	"./resources/icons/cardiogram.png": 25908,
	"./resources/icons/cardiogram_red.png": 36364,
	"./resources/icons/close.png": 37299,
	"./resources/icons/close_2.png": 26916,
	"./resources/icons/close_3.png": 53069,
	"./resources/icons/close_circle.png": 57552,
	"./resources/icons/close_circle_grey.png": 25172,
	"./resources/icons/code.png": 35232,
	"./resources/icons/code.svg": 50180,
	"./resources/icons/code_2.png": 73331,
	"./resources/icons/code_3.png": 34474,
	"./resources/icons/code_og.png": 66315,
	"./resources/icons/criam_just_the_logo.png": 70320,
	"./resources/icons/criam_just_the_logo_black.png": 84660,
	"./resources/icons/criam_just_the_logo_pattern.png": 23963,
	"./resources/icons/criam_logo_people.png": 36901,
	"./resources/icons/criam_shape.png": 50127,
	"./resources/icons/criam_shape.svg": 2525,
	"./resources/icons/criam_shape_bigger.png": 29680,
	"./resources/icons/crunchbase.png": 81063,
	"./resources/icons/crunchbase_icon_red.png": 61795,
	"./resources/icons/date.png": 53603,
	"./resources/icons/date_2.png": 7860,
	"./resources/icons/date_3.png": 24541,
	"./resources/icons/download_icon.png": 92887,
	"./resources/icons/download_icon_blue.png": 95624,
	"./resources/icons/download_icon_white.png": 95645,
	"./resources/icons/email_icon_filled.png": 11148,
	"./resources/icons/email_icon_filled_blue.png": 52401,
	"./resources/icons/email_icon_filled_dark_blue.png": 80834,
	"./resources/icons/email_icon_filled_white_2.png": 74501,
	"./resources/icons/etc.png": 28685,
	"./resources/icons/etc.svg": 90455,
	"./resources/icons/etc_2.png": 28318,
	"./resources/icons/etc_3.png": 16007,
	"./resources/icons/etc_blue.png": 4485,
	"./resources/icons/etc_og.png": 45916,
	"./resources/icons/expand.png": 57815,
	"./resources/icons/external.png": 51898,
	"./resources/icons/external_2.png": 96277,
	"./resources/icons/facebook_icon_filled.png": 43264,
	"./resources/icons/facebook_icon_filled_black.png": 12612,
	"./resources/icons/facebook_icon_filled_blue.png": 79037,
	"./resources/icons/facebook_icon_filled_dark_blue.png": 79446,
	"./resources/icons/fridge.png": 10748,
	"./resources/icons/github_icon_filled.png": 71965,
	"./resources/icons/github_icon_filled_dark_blue.png": 71583,
	"./resources/icons/github_icon_filled_white.png": 42467,
	"./resources/icons/gold_star_1_filled_og.png": 57282,
	"./resources/icons/gold_star_1_og.png": 47761,
	"./resources/icons/gold_star_2_filled_og.png": 37401,
	"./resources/icons/gold_star_2_og.png": 51284,
	"./resources/icons/hamburger.png": 53610,
	"./resources/icons/heart.png": 3227,
	"./resources/icons/home.png": 40746,
	"./resources/icons/info_icon.png": 31363,
	"./resources/icons/info_icon_blue.png": 25196,
	"./resources/icons/info_icon_white.png": 9689,
	"./resources/icons/linkedin.png": 33305,
	"./resources/icons/linkedin_icon_dark.png": 22782,
	"./resources/icons/linkedin_icon_filled.png": 98078,
	"./resources/icons/linkedin_icon_red.png": 68785,
	"./resources/icons/linkedin_icon_red_black.png": 9949,
	"./resources/icons/linkedin_separator.png": 95033,
	"./resources/icons/linkedin_separator_black.png": 86453,
	"./resources/icons/location.png": 10938,
	"./resources/icons/menu.png": 23930,
	"./resources/icons/menu_2.png": 92757,
	"./resources/icons/menu_2_white.png": 20043,
	"./resources/icons/menu_white.png": 31376,
	"./resources/icons/mission.png": 43029,
	"./resources/icons/moon.png": 26108,
	"./resources/icons/moon_dark_blue.png": 23922,
	"./resources/icons/moon_grey.png": 14976,
	"./resources/icons/moon_purple.png": 60959,
	"./resources/icons/moon_white.png": 5082,
	"./resources/icons/our_logo.png": 35491,
	"./resources/icons/phone.png": 65147,
	"./resources/icons/plus.png": 31311,
	"./resources/icons/plus_2.png": 40648,
	"./resources/icons/save-money.png": 13315,
	"./resources/icons/save_money_red.png": 26433,
	"./resources/icons/settings.png": 52808,
	"./resources/icons/settings_blue.png": 8565,
	"./resources/icons/settings_blue_old.png": 19811,
	"./resources/icons/settings_filled_blue_old.png": 17420,
	"./resources/icons/settings_filled_old.png": 25247,
	"./resources/icons/settings_good_old.png": 63552,
	"./resources/icons/settings_old.png": 99318,
	"./resources/icons/settings_old_2.png": 96665,
	"./resources/icons/simple_arrow.png": 82891,
	"./resources/icons/simple_arrow_gold.png": 13898,
	"./resources/icons/simple_arrow_white.png": 11089,
	"./resources/icons/size.png": 8220,
	"./resources/icons/size.svg": 36428,
	"./resources/icons/size_2.png": 18951,
	"./resources/icons/size_3.png": 31262,
	"./resources/icons/size_og.png": 20199,
	"./resources/icons/speed_red.png": 86974,
	"./resources/icons/stopwatch.png": 41462,
	"./resources/icons/suitcase_red.png": 62104,
	"./resources/icons/sun.png": 64853,
	"./resources/icons/sun_white.png": 50315,
	"./resources/icons/sun_yellow.png": 8938,
	"./resources/icons/syphilis.png": 1112,
	"./resources/icons/team.png": 17556,
	"./resources/icons/tokio_school.png": 37250,
	"./resources/icons/tokio_school_black.png": 72102,
	"./resources/icons/tuberculosis.png": 33189,
	"./resources/icons/ubimedical.png": 5476,
	"./resources/icons/ubimedical_black.png": 23400,
	"./resources/icons/up-arrow.png": 57236,
	"./resources/icons/up_arrow.png": 98462,
	"./resources/icons/up_arrow_blue.png": 36783,
	"./resources/icons/up_arrow_dark_blue.png": 88528,
	"./resources/icons/up_arrow_red.png": 14062,
	"./resources/icons/vision.png": 15815,
	"./resources/icons/website.png": 76432,
	"./resources/icons/website_filled_white.png": 75375,
	"./resources/icons/website_white.png": 71966,
	"./resources/icons/what.png": 61529,
	"./resources/icons/youtube.png": 24780,
	"./resources/icons/youtube_black.png": 48384,
	"./resources/images/BCSD_Portugal_RGB-1.png": 67450,
	"./resources/images/afonso_pinheiro.png": 82942,
	"./resources/images/alternative_logo.png": 48688,
	"./resources/images/anders_qvanstrom.jpg": 16392,
	"./resources/images/artesian.png": 60548,
	"./resources/images/artesian_logo_icon_horizontal.png.webp": 82336,
	"./resources/images/bbburst_features.svg": 30079,
	"./resources/images/bcsd.png": 32369,
	"./resources/images/brad_mingus.webp": 21216,
	"./resources/images/carousel/ces.png": 98873,
	"./resources/images/carousel/dinheiro_vivo.png": 90367,
	"./resources/images/carousel/eu_patent.png": 29105,
	"./resources/images/carousel/eu_top_50.png": 10028,
	"./resources/images/carousel/exame_informatica.png": 31284,
	"./resources/images/carousel/fortune_business_insights.png": 58886,
	"./resources/images/carousel/hax_program.png": 9696,
	"./resources/images/carousel/health_pioneers.png": 94470,
	"./resources/images/carousel/jornal_economico.png": 85,
	"./resources/images/carousel/jornal_negocios.png": 63100,
	"./resources/images/carousel/massmedic.png": 24016,
	"./resources/images/carousel/microsoft_imagine.png": 71175,
	"./resources/images/carousel/mobile_health_news.png": 43791,
	"./resources/images/carousel/muc_summit.png": 85469,
	"./resources/images/carousel/nacao_inovadora.png": 39518,
	"./resources/images/carousel/new_in_town.png": 43181,
	"./resources/images/carousel/p2020.png": 38962,
	"./resources/images/carousel/p2020_og.png": 39525,
	"./resources/images/carousel/portugal_inovador.png": 24909,
	"./resources/images/carousel/portuguese_patent.png": 34606,
	"./resources/images/carousel/protechting.png": 14163,
	"./resources/images/carousel/pt_patent.png": 34647,
	"./resources/images/carousel/seal_of_excellence.png": 27862,
	"./resources/images/carousel/sic_noticias.png": 80806,
	"./resources/images/carousel/sosv_human_health_list.png": 67623,
	"./resources/images/carousel/startup_package_austria.png": 70188,
	"./resources/images/carousel/startup_stash.png": 14743,
	"./resources/images/carousel/tech_crunch.png": 40274,
	"./resources/images/carousel/tech_crunch_sf.png": 53160,
	"./resources/images/carousel/tech_eu.png": 52887,
	"./resources/images/carousel/us_patent.png": 76847,
	"./resources/images/carousel/web_summit.png": 31136,
	"./resources/images/compete2030.png": 8121,
	"./resources/images/compete2030_white.png": 38751,
	"./resources/images/criam-400x250.webp": 56383,
	"./resources/images/criam_chaos.svg": 27422,
	"./resources/images/criam_device.png": 67042,
	"./resources/images/criam_image.jpg": 67917,
	"./resources/images/criam_image_2.jpg": 85418,
	"./resources/images/criam_image_3.jpg": 36807,
	"./resources/images/criam_logo.png": 68957,
	"./resources/images/criam_logo_drop.png": 3337,
	"./resources/images/criam_logo_og.png": 19404,
	"./resources/images/criam_logo_white.png": 84611,
	"./resources/images/criam_logo_white_drop.png": 25143,
	"./resources/images/criam_logo_white_og.png": 85178,
	"./resources/images/criam_rain.svg": 90456,
	"./resources/images/criam_tten.svg": 76355,
	"./resources/images/criam_tten_black.svg": 75399,
	"./resources/images/exame_informatica_og.png": 58910,
	"./resources/images/faces.jpeg": 77924,
	"./resources/images/feder.png": 35457,
	"./resources/images/fis.png": 28055,
	"./resources/images/footer_pattern.jpg": 98815,
	"./resources/images/footer_waves.png": 82935,
	"./resources/images/footer_waves.svg": 87357,
	"./resources/images/footer_waves_mobile.png": 17610,
	"./resources/images/footer_waves_mobile_upscaled.png": 98450,
	"./resources/images/footer_waves_upscaled.png": 36601,
	"./resources/images/gabriel_meza.jpeg": 66310,
	"./resources/images/hamburguer_menu_waves.svg": 40216,
	"./resources/images/jornal_economico_og.png": 39591,
	"./resources/images/jornal_negocios.jpg": 56079,
	"./resources/images/lars_wahlstrom.webp": 83081,
	"./resources/images/ljiljana_dukanovic.webp": 22339,
	"./resources/images/logo-FIS.png": 49529,
	"./resources/images/logo-feder-pt-1.png": 6864,
	"./resources/images/margarida_abranches.webp": 29045,
	"./resources/images/microsoft_imagine_og.png": 94327,
	"./resources/images/nacao_inovadora_og.jpg": 76744,
	"./resources/images/norte_2020.png": 82746,
	"./resources/images/norte_2020_logo.png": 62866,
	"./resources/images/nuno_cruz.png": 17982,
	"./resources/images/nuno_cruz_og.png": 94801,
	"./resources/images/ooorganize.svg": 45298,
	"./resources/images/ooorganize_features_3.svg": 57426,
	"./resources/images/ooorganize_team.svg": 91806,
	"./resources/images/ooorganize_team_2.svg": 9565,
	"./resources/images/ooorganize_team_2_black.svg": 15425,
	"./resources/images/ooorganize_team_black.svg": 87130,
	"./resources/images/oooscillate.svg": 2353,
	"./resources/images/oooscillate_black.svg": 15173,
	"./resources/images/oooscillate_red.svg": 18865,
	"./resources/images/page_content/Imagem1.jpg": 47786,
	"./resources/images/page_content/Imagem3.png": 49788,
	"./resources/images/page_content/Imagem4.png": 33395,
	"./resources/images/page_content/agglutination.png": 19201,
	"./resources/images/page_content/background_image.jpg": 6245,
	"./resources/images/page_content/background_image_2.jpg": 67986,
	"./resources/images/page_content/background_image_3.jpg": 24015,
	"./resources/images/page_content/background_image_4.jpg": 15428,
	"./resources/images/page_content/background_image_5.jpg": 93473,
	"./resources/images/page_content/background_image_6.jpg": 6774,
	"./resources/images/page_content/background_image_7.jpg": 93235,
	"./resources/images/page_content/background_image_8.png": 41260,
	"./resources/images/page_content/background_image_8_mobile.png": 75787,
	"./resources/images/page_content/blood.png": 22455,
	"./resources/images/page_content/blood_cells.jpg": 3729,
	"./resources/images/page_content/blood_cells_computer_vision.png": 62962,
	"./resources/images/page_content/blood_draw_1.jpg": 33782,
	"./resources/images/page_content/blood_draw_2.jpg": 4129,
	"./resources/images/page_content/blood_drop_finger.jpg": 14239,
	"./resources/images/page_content/blood_typing.jpeg": 7090,
	"./resources/images/page_content/cartridge.png": 43536,
	"./resources/images/page_content/cartridge_2.jpg": 23771,
	"./resources/images/page_content/cartridge_drawer.png": 97842,
	"./resources/images/page_content/computer_vision.png": 37049,
	"./resources/images/page_content/criam_device_no_background.png": 24837,
	"./resources/images/page_content/criam_device_og - cópia.png": 52218,
	"./resources/images/page_content/criam_device_og.png": 67179,
	"./resources/images/page_content/distributor.jpg": 56488,
	"./resources/images/page_content/distributor.svg": 68750,
	"./resources/images/page_content/distributor_2 - cópia.jpg": 21674,
	"./resources/images/page_content/distributor_2.jpg": 84551,
	"./resources/images/page_content/emergency.jpg": 34932,
	"./resources/images/page_content/emergency_2.jpg": 45659,
	"./resources/images/page_content/emergency_3.jpg": 14174,
	"./resources/images/page_content/half_logo.png": 66536,
	"./resources/images/page_content/investor.jpg": 34363,
	"./resources/images/page_content/investor.svg": 67587,
	"./resources/images/page_content/investor_2.jpg": 59568,
	"./resources/images/page_content/investor_3 - cópia.jpg": 1576,
	"./resources/images/page_content/investor_3.jpg": 60493,
	"./resources/images/page_content/main_image.png": 94918,
	"./resources/images/page_content/needle.jpg": 45318,
	"./resources/images/page_content/partner.jpg": 65617,
	"./resources/images/page_content/partner.svg": 48607,
	"./resources/images/page_content/screen.jpg": 58019,
	"./resources/images/page_content/smart_hardware.png": 77405,
	"./resources/images/page_content/syphilis.jpg": 25300,
	"./resources/images/page_content/syringe - cópia.jpg": 39637,
	"./resources/images/page_content/syringe.jpg": 72964,
	"./resources/images/page_content/tests.png": 85304,
	"./resources/images/page_content/troponin_test.jpg": 79227,
	"./resources/images/page_content/tuberculosis.jpg": 9869,
	"./resources/images/page_content/tuberculosis_2.jpg": 6890,
	"./resources/images/pattern.jpg": 91307,
	"./resources/images/pdr2020.png": 38095,
	"./resources/images/person_placeholder.jpg": 94208,
	"./resources/images/placeholder_image.png": 18732,
	"./resources/images/placeholder_image_1.png": 67612,
	"./resources/images/placeholder_image_2.png": 56343,
	"./resources/images/placeholder_image_3.png": 66350,
	"./resources/images/placeholder_image_4.png": 49441,
	"./resources/images/portugal_inovador_og - cópia.png": 89208,
	"./resources/images/portugal_inovador_og.png": 76737,
	"./resources/images/positive-1.png": 52870,
	"./resources/images/priyank_tyagi.jpeg": 46847,
	"./resources/images/prr.png": 97165,
	"./resources/images/prr_white.png": 66259,
	"./resources/images/publications_and_patents_thumbnails/a_prototype_for_blood_typing.png": 83390,
	"./resources/images/publications_and_patents_thumbnails/automatic_determination_of_human_blood.png": 38033,
	"./resources/images/publications_and_patents_thumbnails/automatic_system_of_human_blood.png": 28499,
	"./resources/images/publications_and_patents_thumbnails/blood_type_classification.png": 20719,
	"./resources/images/publications_and_patents_thumbnails/characterization_of_blood_samples.png": 48653,
	"./resources/images/publications_and_patents_thumbnails/determinacao_automatica.png": 98994,
	"./resources/images/publications_and_patents_thumbnails/determination_of_human_blood.png": 41997,
	"./resources/images/publications_and_patents_thumbnails/development_of_a_human_blood.png": 87527,
	"./resources/images/publications_and_patents_thumbnails/encyclopedia_of_e-health.png": 5862,
	"./resources/images/publications_and_patents_thumbnails/eu_patent.png": 51602,
	"./resources/images/publications_and_patents_thumbnails/mechatronic_system_for_performing.png": 69966,
	"./resources/images/publications_and_patents_thumbnails/prototype_for_determination.png": 34235,
	"./resources/images/publications_and_patents_thumbnails/pt_patent.png": 54476,
	"./resources/images/publications_and_patents_thumbnails/us_patent.png": 85256,
	"./resources/images/publications_and_patents_thumbnails/velocity_and_brightness_control.png": 81420,
	"./resources/images/publications_and_patents_thumbnails/why_do_we_need_portable_PoC_diagnostic_solutions.png": 35593,
	"./resources/images/reetika_dawar.jpeg": 76837,
	"./resources/images/rita_melo.jpg": 55361,
	"./resources/images/rita_salvado_de_melo.jpeg": 38839,
	"./resources/images/rrreflection_team.svg": 95464,
	"./resources/images/sara_evans.jpg": 19636,
	"./resources/images/seal_of_excellence_og.png": 68338,
	"./resources/images/sic_noticias_og.png": 60890,
	"./resources/images/sosv.png": 65592,
	"./resources/images/tawanda_gumbo_md.jpg": 92210,
	"./resources/images/tech_crunch_og.png": 29592,
	"./resources/images/test.jpg": 60085,
	"./resources/images/thierry_loriot.jpg": 21790,
	"./resources/images/tiago_vilacas.webp": 12479,
	"./resources/images/triangles.svg": 63945,
	"./resources/images/ttten_features.svg": 64338,
	"./resources/images/unknown_photo_circled.png": 12391,
	"./resources/images/vania_fernandes.webp": 29225,
	"./resources/images/vasco_lopes.jpg": 861,
	"./resources/images/vijay_verrma.jpeg": 93101,
	"./resources/images/vitor_carvalho.jpg": 66312,
	"./resources/images/vitor_crespo.webp": 47378,
	"./resources/images/vvvortex_team.svg": 80385,
	"./resources/images/wave - cópia.svg": 58293,
	"./resources/images/wave.png": 64418,
	"./resources/images/wave.svg": 54348,
	"./resources/images/wave_technology.png": 31753,
	"./resources/images/wave_technology.svg": 22489,
	"./resources/images/wave_technology_2.png": 33778,
	"./resources/images/wave_technology_2.svg": 6646,
	"./resources/images/wave_technology_3.png": 31643,
	"./resources/images/wave_technology_3.svg": 46183,
	"./resources/images/wave_technology_4.png": 66340,
	"./resources/images/wave_technology_4.svg": 8584,
	"./resources/images/wave_technology_5.png": 6285,
	"./resources/images/wave_technology_old.png": 42151,
	"./resources/images/wavy_lines.svg": 24844,
	"./resources/pdfs/56-Prototype_for_Determination.pdf": 266,
	"./resources/pdfs/A_Prototype_for_Blood_Typing_Based_on_Image_Processing.pdf": 74433,
	"./resources/pdfs/Automatic_Determination_of_Human_Blood_Types_using_Image_Processing_Techniques.pdf": 75623,
	"./resources/pdfs/Automatic_System_of_Human_Blood_Types_Determination.pdf": 21110,
	"./resources/pdfs/Blood_type_classification_using_computer_vision_and_machine_learning.pdf": 56747,
	"./resources/pdfs/Blood_type_classification_using_computer_vision_and_machine_learning_2.pdf": 30140,
	"./resources/pdfs/Determinacao_Automatica_do_Tipo_Sanguineo.pdf": 80698,
	"./resources/pdfs/Development_of_a_Human_Blood_Type_Detection_Automatic_System.pdf": 34477,
	"./resources/pdfs/Encyclopedia_of_E-Health_and_Telemedicine.pdf": 23214,
	"./resources/pdfs/Ferraz2011 Characterization of Blood Samples Using Image Processing Techniques.pdf": 84194,
	"./resources/pdfs/Ferraz2017 Determination of Human Blood Type Using Image Processing Techniques.pdf": 96110,
	"./resources/pdfs/Mechatronic_system_for_performing_blood_pre-transfusion_tests.pdf": 71105,
	"./resources/pdfs/Velocity_and_Brightness_Control_in_Prototype_for_Blood_Type_Determinatio.pdf": 6734,
	"./resources/pdfs/Why_do_we_need_portable_PoC_diagnostic_solutions.pdf": 48682,
	"./resources/pdfs/eu_patent.pdf": 8453,
	"./resources/pdfs/pt_patent.pdf": 98139,
	"./resources/pdfs/us_patent.pdf": 60439,
	"./resources/videos/intro_final.mp4": 62695,
	"./resources/videos/pexels-pavel-danilyuk-6688263_cropped_flipped_slow_2.mp4": 24478,
	"./resources/videos/pexels-pavel-danilyuk-6688263_cropped_flipped_slow_2_mobile.mp4": 24057,
	"./resources/videos/placeholder_video.mp4": 11683,
	"./resources/videos/placeholder_video_2.mp4": 4960,
	"./styles/Roboto/Roboto-Black.ttf": 43704,
	"./styles/Roboto/Roboto-BlackItalic.ttf": 5064,
	"./styles/Roboto/Roboto-Bold.ttf": 41750,
	"./styles/Roboto/Roboto-BoldItalic.ttf": 16850,
	"./styles/Roboto/Roboto-Italic.ttf": 90679,
	"./styles/Roboto/Roboto-Light.ttf": 71149,
	"./styles/Roboto/Roboto-LightItalic.ttf": 88041,
	"./styles/Roboto/Roboto-Medium.ttf": 14358,
	"./styles/Roboto/Roboto-MediumItalic.ttf": 17426,
	"./styles/Roboto/Roboto-Regular.ttf": 59509,
	"./styles/Roboto/Roboto-Thin.ttf": 64938,
	"./styles/Roboto/Roboto-ThinItalic.ttf": 53286,
	"./styles/achievements.module.scss": 94356,
	"./styles/app.module.scss": 43157,
	"./styles/applications.module.scss": 209,
	"./styles/as_seen_in.module.scss": 67268,
	"./styles/bread_crumbs.module.scss": 36821,
	"./styles/carousel.module.scss": 87010,
	"./styles/company.module.scss": 69393,
	"./styles/contact_us.module.scss": 17839,
	"./styles/cover.module.scss": 21373,
	"./styles/farewell_message.module.scss": 90928,
	"./styles/footer.module.scss": 80941,
	"./styles/home.module.scss": 78777,
	"./styles/language_selector.module.scss": 38302,
	"./styles/mission.module.scss": 43534,
	"./styles/navbar.module.scss": 91234,
	"./styles/publications_and_patents.module.scss": 96071,
	"./styles/references.module.scss": 22642,
	"./styles/roadmap.module.scss": 51960,
	"./styles/scroll_up_button.module.scss": 23324,
	"./styles/socials.module.scss": 99704,
	"./styles/team.module.scss": 95059,
	"./styles/technology.module.scss": 26866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81407;